/**
 * Store Programmes
 */
export default {
    state: {
        programmes: [],
        createArrayFiltered: (arrays, key) => {
            let options = []
            arrays.map(array => {
                const optionsfiltered = options.filter((o) => o.label === array[key])
                if (!optionsfiltered.length) {
                    options.push({label: array[key], value: array.id})
                } else {
                    optionsfiltered.forEach((o) => o.value = o.value+','+array.id)
                }
            })

            options =  _.sortBy(options, 'label')
            options.unshift({label: 'Autre programme', value: 'null'})

            return options
        }
    },

    mutations: {
        /**
         * Initialise le state programmes
         */
        setProgrammes: function (state, programmes) {
            state.programmes = programmes
        }
    },

    getters: {
        optionsProgrammeCP: state => {
            return state.createArrayFiltered(state.programmes, 'code_postal')
        },

        optionsProgrammeNom: state => {
            return state.createArrayFiltered(state.programmes, 'nom')
        },

        //todo en attente de confirmation de la nouvelle liste suite au CR du 27/01
        optionsProgrammeType: () => {
            return [
                {
                    label: 'Habitation', value: 'Habitation',
                    lotTypes: [
                        {label:'Appartement', value:'Appartement'},
                        {label:'Chalet', value:'Chalet'},
                        {label:'Maison', value:'Maison'},
                        {label:'Gite', value:'Gite'}
                    ]
                },
                {
                    label: 'Immeuble', value: 'Immeuble',
                    lotTypes: [ {label:'Appartement', value:'Appartement'}]
                },
                {
                    label: 'Camping', value: 'Camping',
                    lotTypes: [ {label:'Mobil home', value:'Mobil home'}]
                },
                {
                    label: 'Résidence de service', value: 'Résidence de service',
                    lotTypes: [
                        {label:'Ehpad/Mapad', value:'Ehpad/Mapad'},
                        {label:'Tourisme', value:'Tourisme'},
                        {label:'Etudiante', value:'Etudiante'},
                        {label:'Affaires', value:'Affaires'},
                        {label:'Seniors', value:'Seniors'},
                    ]
                },
                {
                    label: 'Autre', value: 'Autre',
                    lotTypes: [
                        {label:'Panneaux Solaires', value:'Panneaux Solaires'},
                        {label:'Local Commercial', value:'Local Commercial'},
                        {label:'Bureau', value:'Bureau'},
                        {label:'Garage/Parking', value:'Garage/Parking'},
                        {label:'Chambre d\'Hôte', value:'Chambre d\'Hôte'},
                        {label:'Divers', value:'Divers'}
                    ]
                },
            ]
        },


    },
}
